import { render, staticRenderFns } from "./DashboardForAffiliate.vue?vue&type=template&id=2b0a437e&scoped=true"
import script from "./DashboardForAffiliate.vue?vue&type=script&lang=js"
export * from "./DashboardForAffiliate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0a437e",
  null
  
)

export default component.exports